import { apiGet, apiPost } from './index'

// 获取竞赛详情
export const getExamDetail = (id) => apiGet(`/api/exam/one/${id}`, { id })

// 提交答题
export const submitExamAnswer = (examId, params) => apiPost(`/api/exam/answer/${examId}`, params)

// 获取积分排名列表
export const getExamRank = (id) => apiGet(`/api/exam/rank/${id}`, { id })

// 获取考试剩余时间（秒） 竞赛状态 参赛资格
export const getExamRemainingTime = (examId) => apiGet(`/api/exam/remainingTime/${examId}`)

// 获取用户已选择的答案（用于中途退出后回显）
export const getUserSelectedAnswers = (examId, type) => apiGet(`/api/exam/listUserAnswerCache/${examId}/${type}`)

// 保存用户选中的答案（实时保存，用于断点续答）
export const saveSelectedAnswer = (params) => apiPost(`/api/exam/cacheUserAnswer`, params)

// 给后端标记用户考试开始
export const markTheStartOfTheExam = (examId) => apiGet(`/api/exam/startExam/${examId}`)



// WEBPACK FOOTER //
// ./src/api/contest.js